import icon from '@/constants/Icons'

export default {
  A: {
    description: 'Active',
    icon: icon.unlocked,
    color: 'green'
  },
  C: {
    description: 'Closed',
    icon: icon.locked,
    color: 'red'
  }
}
